import {
  Box,
  Button,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import dayjs from 'dayjs'
import { ChangeEvent, ReactElement } from 'react'
import CsrfTokenTag from '../../../lib/CsrfTokenTag'
import Page from '../../Commons/Page'
import { FeaturedArticle, PaginationType } from '../../types'
import routes from '../../utils/routes'

type Props = {
  articles: FeaturedArticle[]
  pagination: PaginationType
}

function Index(props: Props): ReactElement {
  const articles = props.articles
  const pagination = props.pagination

  const handlePaginationChange = (event: ChangeEvent<unknown>, page: number) => {
    location.href = routes.staff_admin_featured_articles_path({ page })
  }

  return (
    <>
      <Page>
        <Typography variant="h3" sx={{ my: 2 }}>
          特集
        </Typography>
        <Box display="flex" justifyContent="center">
          <Box width="800px">
            <Box display="flex" justifyContent="right" mb={2}>
              <form method="POST" action={routes.staff_admin_featured_articles_path()}>
                <CsrfTokenTag />
                <Button variant="contained" type="submit">
                  新規作成
                </Button>
              </form>
            </Box>
            <Paper className="list">
              <TableContainer>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>タイトル</TableCell>
                      <TableCell>公開日時</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {articles.map((article, i) => {
                      return (
                        <TableRow key={i}>
                          <TableCell align="left">
                            <a href={routes.staff_admin_featured_article_path(article.id)}>
                              {article.id}
                            </a>
                          </TableCell>
                          <TableCell align="left" className="topic">
                            {article.title || 'タイトル未設定'}
                          </TableCell>
                          <TableCell align="left">
                            {article.publishedAt
                              ? dayjs(article.publishedAt).format('YYYY/MM/DD HH:mm')
                              : '公開日時未設定'}
                          </TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', margin: 4 }}>
          <Pagination
            count={pagination.totalPages}
            defaultPage={pagination.currentPage}
            onChange={handlePaginationChange}
          />
        </Box>
      </Page>
    </>
  )
}

export default Index
